module.exports = __webpack_public_path__ + "static/img/quiz.9d77892.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/quiz.png
// module id = SjAa
// module chunks = 2